import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import { api, API_ROOT } from '../../api';
import { fileToBase64 } from '../../utils/files';

const assetLabels = {
  logo: 'Logotip',
  correctSound: 'Zvuk točnog odgovora',
  wrongSound: 'Zvuk netočnog odgovora',
  roundCompleteSound: 'Zvuk uspješno završenog kruga'
};

export function GlobalSettingsPage() {
  const [settings, setSettings] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const load = async () => setSettings(await api.getGlobalSettings());
  useEffect(() => { load(); }, []);

  const uploadAsset = async (slot, file) => {
    try {
      const payload = await fileToBase64(file);
      const next = await api.uploadGlobalAsset(slot, payload);
      setSettings(next);
      setMessage('Datoteka je uspješno učitana.');
      setError('');
    } catch (err) {
      setError(err.message);
      setMessage('');
    }
  };

  const deleteAsset = async (slot) => {
    const next = await api.deleteGlobalAsset(slot);
    setSettings(next);
    setMessage('Datoteka je obrisana.');
    setError('');
  };

  if (!settings) return null;

  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4">Opće postavke</Typography>
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        {Object.entries(assetLabels).map(([slot, label]) => {
          const asset = settings.assets?.[slot] || null;
          return (
            <Card key={slot}>
              <CardContent>
                <Stack spacing={2}>
                  <Typography variant="h6">{label}</Typography>
                  <Typography color="text.secondary">{asset ? `Dodana datoteka: ${asset.fileName}` : 'Datoteka nije dodana.'}</Typography>
                  {asset?.url && slot === 'logo' && <img src={`${API_ROOT}${asset.url}`} alt="Logo" style={{ maxWidth: 240, maxHeight: 120, objectFit: 'contain' }} />}
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Button variant="contained" component="label">
                      Učitaj
                      <input hidden type="file" accept={slot === 'logo' ? 'image/*' : 'audio/mpeg'} onChange={(event) => {
                        const file = event.target.files?.[0];
                        if (file) uploadAsset(slot, file);
                      }} />
                    </Button>
                    <Button color="error" disabled={!asset} onClick={() => deleteAsset(slot)}>Obriši</Button>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          );
        })}
      </Stack>
    </Container>
  );
}
